import { useState, useCallback } from "react";
import { validatePreOpChecklist } from "../utils/mapping";
import { useNotification } from "../../../../contexts/NotificationContext";

export const useFormValidation = (formData) => {
  const [errors, setErrors] = useState({});
  const { showNotification } = useNotification();

  const validateSubmit = useCallback(() => {
    const newErrors = validatePreOpChecklist(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const firstKey = Object.keys(newErrors)[0];
      const el = document.querySelector(`[name="${firstKey}"]`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.focus();
      }
      
      const errorLabels = [
        newErrors.date ? "Surgery Date" : null,
        newErrors.consultant ? "Consultant Name" : null,
        newErrors.room_no ? "Room No." : null,
      ].filter(Boolean);

      showNotification('error', errorLabels.join(', '));
      return false;
    }
    return true;
  }, [formData, showNotification]);

  const clearError = useCallback((field) => {
    if (errors[field]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  }, [errors]);

  return {
    errors,
    setErrors,
    clearError,
    validateSubmit
  };
};
